import axios from 'axios';

const BASE_PATH = 'https://milk.djnch.co.kr/api/api';
const apiKey = 'XoV=nbA12EtP0Wx25tpZk7YoRaKzwWm8y12lBQ==';

const DefaultHeaders = {
  'Content-Type': 'application/json; charset=utf-8', 
};

/*********************공통 정보*******************************/
//토큰 체크
export const checkTokenValidity = async (token) => {
  return token !== ""; 
};

//로그인 정보
export async function getLoginInfo(userId, pwd) {
  try {
      const response = await axios.post(`${BASE_PATH}/Auth/Login/${userId}/${pwd}`, {
        
    }, 
      {
        headers: DefaultHeaders, 
        params: {
          apiKey, // apiKey
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
}

// 메뉴정보
export async function getMenus(userDiv) {
    try {
        const response = await axios.get(`${BASE_PATH}/Auth/Menus`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,      // apiKey
                userDiv ,    // 사용자 구분
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//목장
export async function getFarms() {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/Farms`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//목장(육성우)
export async function getFarmsM1() {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/FarmsM1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//우사
export async function getHouseInfos() {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/HouseInfos`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//공통코드
export async function getCodes(sysKind,codeKind) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/codes`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                sysKind,    // 시스템구분
                codeKind    // 코드종류
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//수의사
export async function getDoctCucode(saupCd) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/DoctCucode`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                saupCd,     // 사업장코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//질병정보
export async function getDiseaseCd(disease_kind) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/DiseaseCd`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                                 // apiKey
                ...(disease_kind && { disease_kind }),  // 축주코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//약품정보
export async function getDiseasePharm(disease_cd) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/DiseasePharm`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,         // apiKey
                disease_cd,     // 질병코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

/**************************낙농단지 개체번호******************************/

//목장 객체번호 
export async function getCustomerCows(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/CustomerCows`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                ...(cuCode && { cuCode }), // 축주코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//개체번호 검색
export async function getCowNoFinds(cuCode,cowNo,cowTraceNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/CowNoFinds`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                ...(cuCode && { cuCode }), // 축주코드
                ...(cowNo && { cowNo }), // 축주코드
                ...(cowTraceNo && { cowTraceNo }), // 축주코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//개체번호 검색 2
export async function getCowNoFinds2(cuCode,searchTxt) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/CowNoFinds2`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                ...(cuCode && { cuCode }), // 축주
                ...(searchTxt && { searchTxt }), // 검색
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//개체번호 검색 3
export async function getCowNoFinds3(cuCode,searchTxt) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/CowNoFinds3`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                ...(cuCode && { cuCode }), // 축주
                ...(searchTxt && { searchTxt }), // 검색
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

/**************************육성우 개체번호******************************/

//개체번호 검색(육성우)
export async function getCowNoFinds2M1(cuCode,searchTxt) {
    try {
        const response = await axios.get(`${BASE_PATH}/Comm/CowNoFinds2M1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                ...(cuCode && { cuCode }), // 축주코드
                ...(searchTxt && { searchTxt }), // 이력제번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


/**************************스마트 낙농단지******************************/
/*********************농가 메인 조회 정보*******************************/
//농가 주간 사육동향
export async function getDashBoardCustomerMain1(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/CustomerMain1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode ,    // 축주코드
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//농가 산차별 착유우 현황
export async function getDashBoardCustomerMain2(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/CustomerMain2`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode ,    // 축주코드
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//농가 비유일수별 착유우 현황
export async function getDashBoardCustomerMain3(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/CustomerMain3`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode ,    // 축주코드
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//농가 산유량별 착유우 현황
export async function getDashBoardCustomerMain4(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/CustomerMain4`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode ,    // 축주코드
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

/*********************직원 메인 조회 정보*******************************/
//직원 주간 사육동향
export async function getDashBoardMain1(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//직원 산차별 착유우 현황
export async function getDashBoardMain2(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main2`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//직원 비유일수별 착유우 현황
export async function getDashBoardMain3(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main3`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//직원 산유량별 착유우 현황
export async function getDashBoardMain4(cuCode) {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main4`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}






/*********************낙농단지 조회 정보*******************************/
//사육두수현황
export async function getM2NumberOfHead(curDate,cowKind,cuCode,houseNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/NumberOfHead`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,          // apiKey
                curDate,         // 날짜
                ...(cowKind && { cowKind }), // 품종
                ...(cuCode && { cuCode }), // 축주
                ...(houseNo && { houseNo }), // 우사번호
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//납유현황 조회
export async function getM2StatusOfLeadMilk(curDate) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/StatusOfLeadMilk`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,   // apiKey
                curDate   // 날짜
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//일자별 납유량
export async function getM2LeadMilkByDate(cuCode, yearMonth, chasu) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/LeadMilkByDate`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,         // apiKey
                ...(cuCode && { cuCode }), // 축주코드
                ...(yearMonth && { yearMonth }), // 년월
                ...(chasu && { chasu }), // 차수
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//개체별 일별 착유량
export async function getM2CowDailyFlowMilk(cuCode, yearMonth, cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowDailyFlowMilk`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,         // apiKey
                ...(cuCode && { cuCode }), // 축주코드
                ...(yearMonth && { yearMonth }), // 년월
                ...(cowNo && { cowNo }), // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//사육개체 현황
export async function getM2CurrentStatsOfBreedingCow(cuCode,breedStatus,houseNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CurrentStatsOfBreedingCow`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                         // apiKey
                ...(cuCode && { cuCode }),      // 축주코드
                breedStatus,                    // 사육상태(1:사육중,2:미사육) 
                ...(houseNo && { houseNo }),    // 우사번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//사육개체 현황(산차)
export async function getM2CurrentStatsOfBreedingCowBirth(cuCode,breedStatus,houseNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CurrentStatsOfBreedingCowBirth`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                         // apiKey
                ...(cuCode && { cuCode }),      // 축주코드
                breedStatus,                    // 사육상태(1:사육중,2:미사육) 
                ...(houseNo && { houseNo }),    // 우사번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//일별 사육두수 변화
export async function getM2DailyCowCountChange(cuCode,yearMonth,cowKind) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/DailyCowCountChange`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                yearMonth,  // 년월
                cuCode,     // 축주코드
                cowKind     // 품종코드
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//두당 산유량 십분위 현황
export async function getM2CowHeadDecimalOfFlows(curDate,cuCode,viewDiv,fromVal,toVal) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowHeadDecimalOfFlows`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                curDate,    // 일자
                cuCode,     // 목장코드
                viewDiv,    // 조회구분
                fromVal,    // 십분위 From
                toVal,      // 십분위 To
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//두당 산유량 분포현황(무게)
export async function getM2CowHeadDistribution1(curDate,cuCode,viewDiv) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/cowHeadDistribution1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                curDate,                    // 기준일자
                ...(cuCode && { cuCode }),  // 목장코드
                viewDiv,                    // 조회구분(W:주간,M:월간)
                
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//두당 산유량 분포현황(분위)
export async function getM2CowHeadDistribution2(curDate,cuCode,viewDiv) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/cowHeadDistribution2`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                curDate,                    // 기준일자
                ...(cuCode && { cuCode }),  // 목장코드
                viewDiv,                    // 조회구분(W:주간,M:월간)
                
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//송아지 분만 기록
export async function getM2CalfRecord(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/calfRecord`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축주코드
                yearMonth,  // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//송아지 분만 기록(일령)
export async function getM2CalfRecordDays(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/calfRecordDays`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축주코드
                yearMonth,  // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//수정기록
export async function getM2EmbLog(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/EmbLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축주코드
                yearMonth,  // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//사육비 정산 내역
export async function getM2BreedingFee(cuCode,yearMonth, chasu) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/BreedingFee`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축주코드
                yearMonth,  // 년월
                chasu,      // 차수
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//사육비 정산 내역 (신규)
export async function getM2BreedingFeeNew(cuCode,yearMonth, chasu) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/BreedingFeeNew`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축주코드
                yearMonth,  // 년월
                chasu,      // 차수
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//개체정보 조회
export async function getM2CowInfo(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowInfo`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 우사 이동기록
export async function getM2CowHouseLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowHouseLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 수정기록
export async function getM2CowEmbLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowEmbLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 진료기록
export async function getM2CowTreatLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CowTreatLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


// 송아지 사육현황
export async function getM2CalfStatus(curDate) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/CalfStatus`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                curDate,     // 날짜
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 진료기록
export async function getM2TreatLog(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/TreatLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축추코드
                yearMonth,  // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//송아지 분만기록
export async function postCalfReg(momCowNo, birthYMD, calfSex, smsSendYN) {
  try {
    const response = await axios.post(
      `${BASE_PATH}/M2View/CalfReg`,
      {
        // Request Body에 포함될 데이터
        momCowNo: momCowNo,
        birthYMD: birthYMD,
        calfSex: calfSex,
        smsSendYN: smsSendYN,
      },
      {
        headers: {
          ...DefaultHeaders,
        },
        params: {
          apiKey, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error;
  }
}

//송아지 현황
export async function getCalf(cuCode,viewDiv,fromDt,toDt) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/calf`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                cuCode,                     // 축추코드
                viewDiv,                    // 조회구분
                ...(fromDt && { fromDt }),  // 출생일자 From
                ...(toDt && { toDt }),      // 출생일자 To
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//일별 개체별 착유량
export async function getDayCowMilk(cuCode,ymd) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/DayCowMilk`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                cuCode,                     // 축추코드
                ymd,                        // 일자
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//농가별 월별 검정성적 기록
export async function getDcicCuCode(cuCode,yymm ) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/DcicCuCode`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                cuCode,                     // 축추코드
                yymm,                        // 일자
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//개체별 월별 검정성적 기록
export async function getDcicCow(cowNo ) {
    try {
        const response = await axios.get(`${BASE_PATH}/M2View/DcicCow`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                     // apiKey
                cowNo,                        // 일자
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

/************************** 자연으로 농장 *******************************/
/************************농가 메인 조회 정보*****************************/
//주간 사육동향 (육성우)
export async function getDashBoardMain1M1() {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main1M1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//입식구분별 (육성우)
export async function getDashBoardMain2M1() {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main2M1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//우사별 (육성우)
export async function getDashBoardMain3M1() {
    try {
        const response = await axios.get(`${BASE_PATH}/DashBoard/Main3M1`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
            },
        });

        return response.data; 
    } catch (error) {
        throw error; 
    }
}

/********************* 자연으로 농장 조회 정보***************************/

//개체정보 조회
export async function getM1CowInfo(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowInfo`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 수정 요구사항
export async function getM1CowInfoCustomerDefault(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowInfoCustomerDefault`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 우사 이동기록
export async function getM1CowHouseLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowHouseLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 수정기록
export async function getM1CowEmbLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowEmbLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체정보 - 진료기록
export async function getM1CowTreatLog(cowNo) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowTreatLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


// 사육두수 현황 (육성우-상단폼)
export async function getM1NumberOfHeadTop(curDate) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/NumberOfHeadTop`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,         // apiKey
                curDate,        // 일자
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 사육두수 현황 (육성우-하단폼)
export async function getM1NumberOfHeadBottom(curDate) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/NumberOfHeadBottom`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,         // apiKey
                curDate,        // 일자
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

//수정기록 (육성우)
export async function getM1EmbLog(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/EmbLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,                         // apiKey
                ...(cuCode && { cuCode }),      // 축주코드
                yearMonth,                      // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 진료기록 (육성우)
export async function getM1TreatLog(cuCode,yearMonth) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/TreatLog`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cuCode,     // 축추코드
                yearMonth,  // 년월
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}

// 개체진료기록 (육성우-개체정보)
export async function getM1CowStatus(cowNo ) {
    try {
        const response = await axios.get(`${BASE_PATH}/M1View/CowStatus`, {
            headers: DefaultHeaders, 
            params: { 
                apiKey,     // apiKey
                cowNo ,     // 개체번호
            },
        });
        return response.data; 
    } catch (error) {
        throw error; 
    }
}


//개체진료기록(등록)
export async function postPharmUseLog(sauP_CD, ymd, coW_NO, diseasE_CD, pharM_CD1, pharM_DOSE1, pharM_AMT1
        , pharM_CD2, pharM_DOSE2, pharM_AMT2, pharM_CD3, pharM_DOSE3, pharM_AMT3, milkinG_STOP, memo, docT_CUCODE) {
  try {
    const response = await axios.post(
      `${BASE_PATH}/M1View/PharmUseLog`,
      {
        // Request Body에 포함될 데이터
        sauP_CD: sauP_CD,
        ymd: ymd,
        coW_NO: coW_NO,
        diseasE_CD: diseasE_CD,
        pharM_CD1: pharM_CD1,
        pharM_DOSE1: pharM_DOSE1,
        pharM_AMT1: pharM_AMT1,
        pharM_CD2: pharM_CD2,
        pharM_DOSE2: pharM_DOSE2,
        pharM_AMT2: pharM_AMT2,
        pharM_CD3: pharM_CD3,
        pharM_DOSE3: pharM_DOSE3,
        pharM_AMT3: pharM_AMT3,
        milkinG_STOP: milkinG_STOP,
        memo: memo,
        docT_CUCODE: docT_CUCODE,
      },
      {
        headers: {
          ...DefaultHeaders,
        },
        params: {
          apiKey, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error;
  }
}
